export * from './profile-attach-delete.actions';
export * from './profile-attach-delete.effect';
export * from './profile-attach-del.reducer';
export * from './profile-attach-del.service';
